export default function () {
  this.doLoad()
  this.getTowersDweller()
}



// WEBPACK FOOTER //
// ./src/app/dweller/profile/me/components/overview/components/info/resources/mounted.js